import React, {useEffect} from 'react';
import {connect, Provider} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import {Helmet} from 'react-helmet-async';
import Header from '../../Block/HeaderMainBlock/MainHeader';
import Footer from 'app/Components/Shared/Footer/Footer.js';
import SalesHeader from 'app/Components/Shared/SalesHeader/SalesHeader';
import Loader from '../Loader/Loader';
import {ContentLinkService} from '@episerver/spa-core/Models/ContentLink';
import helper from '../../../utilities/helper';
import Config from '../../../Config';
//import Butterfly from 'app/Components/Shared/Butterfly';
import SelfCareHeader from 'app/Components/Page/SelfCarePage/partials/header/SelfCareHeader';
import CmsComponent from '@episerver/spa-core/Components/CmsComponent';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';
import AuthenticationPopUp from '../../Shared/AuthenticationPopUp/AuthenticationPopUp';
import CookiesPopup from 'app/Components/Shared/CookiesPopup/CookiesPopup';
import {setRedirectUrl, forceExtendedOtp} from '../../../utilities/authentication/authenticationSlice';
import {ScriptManager} from './ScriptManager';
import {tagMap} from './constant';
import ThemeLoader from '../../../utilities/theme/ThemeLoader';

const CellcomLayoutPage = (props) => {


  const storage = window.localStorage || window.sessionStorage;
  //console.log('CellcomLayoutPage prerenderReady', window.prerenderReady);
  let page = [];
  let pageData = props.pageData;

  const isKmsiPage = props.path?.includes('/kmsi');
  let isKmsiLiteReturn = helper.getUrlParameter('loginLite') == 'true';

  page.push(<ThemeLoader key={'theme-loader'} startPage={props.layout.startPage} />);

  if (process.env.NODE_ENV === 'development' && helper.getUrlParameter('uiCatalog') === 'true') {
    const UiCatalog = require('../../../dev/UiCatalog/UiCatalog').default;
    page.push(<UiCatalog key={'ui-catalog'} />);
    return page;
  }

  page.push(
    <Provider store={props.layout.context.getStore()} key={'website-loader'}>
      <Loader overlay={true} context={props.layout.context} />
    </Provider>,
  );

  if (!props.authentication.isAuthenticateFinish) {
    return null;
  }

  const Seo = () => (
    <Helmet key={`website-helmet-seo`}>
      <title>{getCurrentPageTitle(pageData) + ' :: ' + (window.Config.brand_Name_HE || '')}</title>
      <meta name='description' content={getCurrentPageDescription(pageData)} />
      <meta name='searchKeyWords' content={getCurrentPageSearchKeyWords(pageData)} />
      <meta name='keywords' content={getCurrentPageKeywords(pageData)} />
      <meta property='og:title' content={getCurrentPageTitle(pageData)} />
      <meta property='og:image' content={getCurrentPageImageUrl(pageData)} />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='630' />
      <meta property='og:description' content={getCurrentPageDescription(pageData)} />
      <meta name='format-detection' content='telephone=no' />
      <meta property='og:type' content='website' />
      <meta property='og:site_name' content='Cellcom' />
      <link rel='canonical' href={getCurrentPageCanonical(pageData)} />
    </Helmet>
  );

  if (!isKmsiPage) {
    //console.log('[CellcomLayout] render ScriptManager and seo-scripts');
    page.push(<Seo key={'seo-scripts'} />);
    //qa,production
    page.push(<ScriptManager key={'ScriptManager'} />);
  }

  //---------------------------------------
  const result = checkPagePermissions(pageData);

  if (result.navigateTo) {
    if (!props.initApp.isGlobalConfigFinish) {
      return null;
    }

    const redirectUrl = encodeURIComponent(location.pathname + location.search);

    if (result.navigateTo == 'otp') {
      storage.setItem('loginData', JSON.stringify({redirectUrl: redirectUrl, forceExtended: false, loginType: result.loginType}));
      //buildUrlAndOpenSameWindow(Config.newLoginUrl);
      authenticationProvider.goToOtp(true, redirectUrl, false, result.loginType);
      return null;
    }
    if (result.navigateTo == 'otpAndOtpExtended') {
      storage.setItem('loginData', JSON.stringify({redirectUrl: redirectUrl, forceExtended: true}));
      //buildUrlAndOpenSameWindow(Config.newLoginUrl);
      authenticationProvider.goToOtp(true, redirectUrl, true);
      return null;
    }
    if (result.navigateTo == 'redirectToLogin') {
      const template = helper.getLoginTemplate(pageData.url);
      authenticationProvider.redirectToLogin(pageData.url, pageData.url, template);
      return null;
    }
  }

  if (result.action) {
    page.push(<AuthenticationPopUp action={result.action} />);
    return page;
  }

  const loginDataStr = storage.getItem('loginData');
  if (loginDataStr) {
    const loginData = JSON.parse(loginDataStr);
    props.setRedirectUrl(loginData.redirectUrl);
    props.forceExtendedOtp(loginData.forceExtended);
    storage.setItem('loginData', '');
  }
  //---------------------------------------

  // Property to redirect to other page
  if (pageData && pageData.forceRedirect && pageData.forceRedirect.value && pageData.forceRedirect.value.url) {
    EpiContext.navigateTo(pageData.forceRedirect.value.url);
  }

  const organizationState = props.layout.context.getStore().getState().welcomeBlock?.organizationState;
  const businessTarget = pageData.isBusinessNavigation;

  if (isJsonString(pageData.googleStructureJsonData?.value)) {
    page.push(
      <Helmet key={`website-helmet-google-structure`}>
        <script type='application/ld+json'>{pageData.googleStructureJsonData?.value}</script>
      </Helmet>,
    );
  }

  if (pageData.disableIndexing?.value === true) {
    page.push(
      <Helmet key={'website-helmet-disable'}>
        <meta name='robots' content='noindex' />
      </Helmet>,
    );
  }

  if (!(pageData.hideSiteHeader?.value === true || isKmsiLiteReturn === true || isKmsiPage)) {
    if (!(organizationState?.hideFooterAndHeader?.value && pageData.url === Config.lobbyUrl)) {
      page.push(
        <Provider key={'website-empty'} store={props.layout.context.getStore()}>
          {pageData.isDisplaySaleHeader?.value === true ? (
            <SalesHeader />
          ) : (
            <Header
              context={props.layout.context}
              startPage={props.layout.startPage}
              path={props.layout.path}
              key={`website-header`}
              isBusinessNavigation={businessTarget}
              isDisplayFullAuthorizationHeader={pageData.isDisplayFullAuthorizationHeader?.value}
            />
          )}
        </Provider>,
      );
    }
  }

  if (pageData.isDisplaySelfCareHeader?.value) {
    page.push(
      //Nadav Landesman - SelfCare Header
      <SelfCareHeader key={'SelfCareHeader'} startPage={props.layout.startPage} context={props.layout.context}></SelfCareHeader>,
    );
  }

  //text by tags

  const renderTextByTags = () => {
    const textByTags = props.layout.expandedValue?.textByTags?.value || props.layout.expandedValue?.TextByTags;
    if (!textByTags || !Array.isArray(textByTags)) {
      return null;
    }

    return textByTags
      .map((item, index) => {
        const tagValue = item.tag;
        const text = item.text;
        const removeFromScreenReader = item.removeFromScreenReader ?? false;
        if (!tagValue || tagValue === 0 || !text) {
          return null;
        }

        const tagName = tagMap[tagValue];
        if (!tagName) {
          return null;
        }
        return React.createElement(tagName, {
          key: `text-by-tag-${index}`,
          dangerouslySetInnerHTML: {__html: text},
          className: 'sr-only',
          'aria-hidden': removeFromScreenReader ? 'true' : 'false',
        });
      })
      .filter(Boolean); // Remove null entries
  };

  const textByTagElements = renderTextByTags();
  if (textByTagElements && textByTagElements.length > 0) {
    page.push(<React.Fragment key={'text-by-tags'}>{textByTagElements}</React.Fragment>);
  }

  page.push(
    <CmsComponent
      context={props.layout.context}
      contentLink={props.layout.page}
      expandedValue={props.layout.expandedValue}
      key={`website-body`}
      actionName={props.layout.actionName}
      actionData={props.layout.actionData}
    />,
  );
  if (!(pageData.hideSiteFooter.value === true || isKmsiLiteReturn === true)) {
    if (!(organizationState?.hideFooterAndHeader?.value && pageData.url === Config.lobbyUrl)) {
      page.push(
        <Footer key={'website-footer'} context={props.layout.context} path={props.layout.path} startPage={props.layout.startPage} />,
      );
    }
  }

  if (!isKmsiPage && window.localStorage && window.localStorage.getItem('isCookiesAccepted') != 'true')
    page.push(<CookiesPopup key={'website-terms-policy'} termsPolicyLink={props.layout.startPage?.termsPolicyLink?.value} />);

  /*
    if (!isKmsiPage) {
        page.push(<Butterfly doneLoading={!!props.layout.startPage && process.env.NODE_ENV === 'production'} key={`butterfly`} />);
    }
    */

  return page;

  function getCurrentPageTitle(page) {
    return page.metaTitle?.value || (typeof page.name == 'string' ? page.name : page.name?.value);
  }

  function getCurrentPageKeywords(page) {
    return page.keywords?.value || (typeof page.name == 'string' ? page.name : page.name?.value);
  }

  function getCurrentPageDescription(page) {
    return page.pageDescription?.value || '';
  }

  function getCurrentPageSearchKeyWords(page) {
    return page.searchKeyWords?.value || '';
  }

  function getCurrentPageCanonical(page) {
    return Config.staticWebSiteUrl + page.url;
  }

  function getCurrentPageImageUrl(page) {
    return Config.epiBaseUrl + page.pageImage?.value?.url;
  }

  function isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  //-----------------------------------------
  function checkPagePermissions(pageData) {
    const authentication = props.layout.context.getStore().getState().authentication;
    const loginDataFromStorage = authenticationProvider.getLoginData();

    var pageLoginType = null;
    if(pageData.url == props.dynamicLoginType?.PageUrl){
      pageLoginType = props.dynamicLoginType?.LoginType;
    }
    var loginTypeEnum = pageLoginType || pageData.loginTypeEnum?.value;
    const loginType = getLoginType(loginTypeEnum);
    const isPrimaryContact = authentication.loginData?.userDetails?.IsPrimaryContact;

    const isOtpAuthenticated = authentication.loginData.isOtpAuthenticated || authentication.loginData.isSilentOtpAuthenticated;
    const isOtpExtendedAuthenticated = authentication.loginData.isOtpExtendedAuthenticated;
    const isFullAuthenticated = authentication.loginData.isFullAuthenticated;
    // Prefer store; fall back to storage (SPA navigate right after OTP can race Redux connect)
    const roleList =
      authentication.loginData?.userDetails?.RoleList ||
      loginDataFromStorage?.userDetails?.RoleList;

    let result = {navigateTo: '', action: ''};

    switch (loginType) {
      case 'ANONYMOUS':
        break;
      case 'OTP':
        if (!isOtpAuthenticated && !isOtpExtendedAuthenticated && !isFullAuthenticated) {
          result.navigateTo = 'otp';
        }
        break;
      case 'OTPEXTENDED':
        if (!isOtpExtendedAuthenticated && !isFullAuthenticated) {
          if (isOtpAuthenticated) {
            result.action = 'otpExtended';
          } else {
            result.navigateTo = 'otpAndOtpExtended';
          }
        }
        break;
      case 'CREDENTIALS':
        if (!isFullAuthenticated) {
          if (isOtpAuthenticated) {
            result.action = 'accountOnlyMessage';
            break;
          }
          if (isOtpExtendedAuthenticated && isPrimaryContact) {
            result.action = 'identityCompletion';
            break;
          }
          result.navigateTo = 'redirectToLogin';
        }
        break;  
      
      case 'ORGANIZATIONEMPLOYEEFAMILY':
      case 'ORGANIZATIONEMPLOYEECREDENTIALS':
          if (!roleList || !roleList.includes(loginType)) {
              result.navigateTo = 'otp';
              result.loginType = loginType;
              break;
        }
    }

    return result;
  }

  function getLoginType(loginTypeEnum) {
    if (typeof loginTypeEnum === 'string' && Number.isNaN(Number(loginTypeEnum))) {
      return loginTypeEnum.toUpperCase();
    }
    switch (Number(loginTypeEnum)) {
      case 0:
        return 'ANONYMOUS';
      case 1:
        return 'OTP';
      case 2:
        return 'OTPEXTENDED';
      case 3:
        return 'CREDENTIALS';
      case 4:
        return 'ORGANIZATIONEMPLOYEEFAMILY';
      case 5:
        return 'ORGANIZATIONEMPLOYEECREDENTIALS';
      default:
        return 'ANONYMOUS';
    }
  }
  //-----------------------------------------
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    initApp: state.initApp,
    dynamicLoginType: state.startPage.dynamicLoginType,
  };
};

const mapDispatchToProps = {setRedirectUrl, forceExtendedOtp};

export default connect(mapStateToProps, mapDispatchToProps)(CellcomLayoutPage);
